"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// taken from https://stackoverflow.com/a/18391400/168012
// Wraps JSON.stringify to allow conversion of errors

/**
 * see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#The_replacer_parameter
 */
function replaceErrors(key, value) {
  if (value instanceof Error) {
    const error = {};
    Object.getOwnPropertyNames(value).forEach(k => {
      // @ts-ignore
      error[k] = value[k];
    });
    return error;
  }
  return value;
}

/**
 * see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
 */
const replaceErrorsAndReplaceCircularReferences = () => {
  const seen = new WeakSet();
  return (key, value) => {
    const val2 = replaceErrors(key, value);
    if (typeof val2 === 'object' && val2 !== null) {
      if (seen.has(val2)) {
        return null;
      }
      seen.add(val2);
    }
    return val2;
  };
};
const toJson = o => JSON.stringify(o, replaceErrorsAndReplaceCircularReferences());
var _default = exports.default = toJson;